import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6.32 2.58a49.3 49.3 0 0 1 11.36 0c1.497.174 2.57 1.46 2.57 2.93v15.492a.75.75 0 0 1-1.085.671L12 18.091l-7.165 3.582a.75.75 0 0 1-1.085-.67V5.508c0-1.47 1.073-2.755 2.57-2.93",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }